import React from 'react';
import './QuickActions.css';

function QuickActions({ currentUser, onNavigate }) {
  const actions = [
    {
      icon: '🎁',
      title: 'Browse Giveaways',
      description: 'View all active giveaways',
      action: () => onNavigate('giveaways'),
      color: '#6361e7',
    },
    {
      icon: '⚡',
      title: 'Get Extra Entries',
      description: 'Boost your chances',
      action: () => onNavigate('extra-entries'),
      color: '#10de82',
    },
    {
      icon: '📢',
      title: 'Announcements',
      description: 'Latest updates',
      action: () => onNavigate('announcements'),
      color: '#ff4d6d',
    },
    {
      icon: '💬',
      title: 'Chat',
      description: 'Join the conversation',
      action: () => onNavigate('chat'),
      color: '#6e85fa',
    },
    {
      icon: '👥',
      title: 'Staff Team',
      description: 'Meet the team',
      action: () => onNavigate('staff'),
      color: '#f59e0b',
    },
    {
      icon: '📚',
      title: 'WikiDrop',
      description: 'Learn more',
      action: () => onNavigate('wikidrop'),
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="quick-actions">
      <h2 className="quick-actions-title">Quick Actions</h2>
      <div className="quick-actions-grid">
        {actions.map((action, index) => (
          <div
            key={index}
            className="quick-action-card"
            onClick={action.action}
            style={{ '--action-color': action.color }}
          >
            <div className="quick-action-icon">{action.icon}</div>
            <h3>{action.title}</h3>
            <p>{action.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuickActions;

